import {
    FinancePaymentCreationForm,
    FinancePaymentUpdateForm,
    FinancePaymentViewModel,
    FindFinancePaymentsQuery,
    FinancePaymentsResponse,
    FinancePaymentsAmountResponse,
    FinancePaymentsAmountQuery,
    GenerateFinancePaymentReportParams,
} from 'chaika-frontend-types/frontend-cms';
import { axios } from '@lib/axios';
const BASE_URL = '/api/finance/payment';

export class FinancePaymentApi {
    public static async find(params: FindFinancePaymentsQuery): Promise<FinancePaymentsResponse> {
        const res = await axios.get(BASE_URL, { params });

        return res.data;
    }

    public static async getAmountSum(params: FinancePaymentsAmountQuery): Promise<FinancePaymentsAmountResponse> {
        const res = await axios.get(`${BASE_URL}/amount-sum`, { params });

        return res.data;
    }

    public static async payment(params: FinancePaymentCreationForm): Promise<void> {
        await axios.post(BASE_URL, params);
    }

    public static async update(id: string, data: FinancePaymentUpdateForm): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, data);
    }

    public static async issueReceipt(id: string): Promise<void> {
        await axios.post(`${BASE_URL}/${id}/receipt`);
    }

    public static async get(id: string): Promise<FinancePaymentViewModel> {
        const res = await axios.get(`${BASE_URL}/${id}`);

        return res.data.payment;
    }

    public static async generateReport(params: GenerateFinancePaymentReportParams): Promise<Blob> {
        const res = await axios.get(`${BASE_URL}/generate-report`, { params, responseType: 'blob', timeout: 0 });

        return res.data;
    }
}
